export var months = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
];

export default function formatDay(day) {
    return day > 0 & day <= 12 ? months[day-1]:'invalid';
}